<div class="w-[100%]">
  <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2">
    <mat-form-field appearance="outline" class="!min-w-[430px] mr-[40px]">
      <mat-label>Select Project Type</mat-label>
      <mat-select [(value)]="projectType">
        <mat-option
          class="hover:!bg-[#fae8e1] !border-b"
          *ngFor="let parent of parants[0]"
          [value]="parent?.name"
          (click)="onSelectionMainProjectType(parent?.name, parent?.id)"
        >
          {{ parent?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div
      class=" "
      *ngIf="
        ((childs[0] && childs[0]?.length > 0) || projectSubType) &&
        selectedType !== 'Custom'
      "
    >
      <div class="">
        <mat-form-field appearance="outline" class="!min-w-[430px]">
          <mat-label>Select Project Sub Type</mat-label>
          <mat-select [(value)]="projectSubType">
            <!-- Sync value -->

            <mat-option
              class="hover:!bg-[#fae8e1] !border-b"
              *ngFor="let child of childs[0]"
              [value]="child?.name"
              (click)="onSelectionSubProjectType(child?.name, child?.id)"
            >
              {{ child?.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
<!-- Custom  -->
<div class="flex" *ngIf="selectedType === 'Custom'">
  <div class="">
    <mat-form-field appearance="outline" class="!min-w-[430px]">
      <mat-label>Select Parent</mat-label>
      <mat-select [(value)]="customParent">
        <mat-option
          class="hover:!bg-[#fae8e1] !border-b"
          *ngFor="let parent of parants[0]"
          [value]="parent?.name"
          (click)="onSelectionCustomParent(parent?.name, parent?.id)"
        >
          {{ parent?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<form [formGroup]="form">
  <div class="flex items-center mt-[18px]" *ngIf="selectedType === 'Custom'">
    <mat-form-field appearance="outline" class="!w-[430px]">
      <mat-label>Enter Custom Type</mat-label>
      <input
        matInput
        type="text"
        id="customType"
        formControlName="customType"
        class="p-2 mt-1 block sm:text-sm"
        placeholder=""
      />
    </mat-form-field>
  </div>
</form>
